import { render } from "./CashierDashboardPage.vue?vue&type=template&id=110cb8b9"
import script from "./CashierDashboardPage.vue?vue&type=script&lang=js"
export * from "./CashierDashboardPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__